import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { LIVE_FORMS } from "@/pages/VisaCountriesPage";
import { FormFrame } from "@/components/common/FormFrame";

// Schema-driven country intake form (public/forms/<country>.html), shown under the site header.
export const CountryApplyPage = () => {
  const { country } = useParams();
  if (!LIVE_FORMS.includes(country)) return <Navigate to="/apply/visa" replace />;
  return <FormFrame src={`/forms/${country}.html`} title={`${country} application form`} testid={`${country}-apply-page`} />;
};

export default CountryApplyPage;
